import styled from 'styled-components'
import { TitleRow } from '../../../components/UI/'

export const StyledRow = styled.div`
  padding: 0 5px;
  & > section {
    &:first-of-type {
      padding: 16px 24px;
      background: rgba(255, 255, 255, 0.08);
      border: 1px solid rgba(255, 255, 255, 0.1);
      backdrop-filter: blur(20px);
      box-shadow:
        0 4px 20px rgba(0, 0, 0, 0.1),
        inset 0 1px 0 rgba(255, 255, 255, 0.1);
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-radius: 12px;
      margin-bottom: 16px;
      position: relative;
      overflow: visible;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      z-index: 10;

      @media (max-width: 767px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
      }

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(
          135deg,
          rgba(255, 255, 255, 0.04) 0%,
          rgba(255, 255, 255, 0.01) 50%,
          rgba(237, 162, 17, 0.02) 100%
        );
        border-radius: 12px;
        pointer-events: none;
      }

      &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 1px;
        background: linear-gradient(
          90deg,
          transparent 0%,
          rgba(255, 255, 255, 0.1) 50%,
          transparent 100%
        );
      }

      h1 {
        font-style: normal;
        font-weight: 600;
        font-size: 20px;
        line-height: 30px;
        color: rgba(255, 255, 255, 0.95);
        margin: 0;
        letter-spacing: 0.5px;
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
        position: relative;
        z-index: 1;
      }

      & > h2 {
        color: #eda211;
        font-weight: 600;
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
        position: relative;
        z-index: 1;
      }

      & > p {
        font-size: 17px;
        font-style: normal;
        letter-spacing: -0.67px;
        line-height: normal;
        text-decoration: underline;
        padding-left: 40px;
        cursor: pointer;
        color: rgba(255, 255, 255, 0.8);
        transition: color 0.3s ease;
        position: relative;
        z-index: 1;

        &:hover {
          color: #eda211;
        }
      }
    }
  }
  .events__games-container {
    padding: 18px 31px 18px;
    display: flex;
    gap: 30px;
    overflow-y: auto;

    min-height: 150px;
  }
`
const Styled = {
  StyledTitleRow: styled(TitleRow)`
    margin: 0 0 20px;

    @media (max-width: 767px) {
      flex-direction: column;
      align-items: flex-start;
    }
  `,
  Tabs: styled.div`
    display: flex;
    align-items: center;

    @media (max-width: 767px) {
      margin: 6px 0;
    }

    div {
      cursor: pointer;
      transition: all 0.3s ease;
      font-weight: 500;
      font-size: 14px;

      &:hover {
        color: #eda211;
      }
    }

    div.active {
      color: #eda211;
    }

    div + div {
      margin-left: 30px;
    }
  `,
  ProgressRow: styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
    gap: 24px;

    @media (max-width: 767px) {
      gap: 16px;
      margin-top: 16px;
    }
  `,

  ProgressCol: styled.div`
    padding: 0;
    width: calc(50% - 12px);
    position: relative;

    @media (max-width: 767px) {
      width: 100%;
      padding: 0;
    }
  `,

  ProgressTitle: styled.div`
    text-align: center;
    margin: 0 0 20px;
    font-weight: 600;
    font-size: 18px;
    color: rgba(255, 255, 255, 0.95);
    letter-spacing: 0.5px;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
    position: relative;

    &::after {
      content: '';
      position: absolute;
      bottom: -8px;
      left: 50%;
      transform: translateX(-50%);
      width: 40px;
      height: 2px;
      background: linear-gradient(
        90deg,
        #eda211 0%,
        rgba(237, 162, 17, 0.5) 100%
      );
      border-radius: 1px;
    }
  `,
  PerformanceTitle: styled.div`
    font-weight: bold;
    font-size: 18px;
    line-height: 27px;
    color: #eda211;
    margin: 0 0 16px;

    @media (max-width: 767px) {
      text-align: center;
    }
  `,
  // New card-based performance layout
  PerformanceGrid: styled.div`
    margin: 0 20px;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 16px;

    @media (max-width: 767px) {
      margin: 0 10px;
      grid-template-columns: repeat(2, 1fr);
      gap: 12px;
    }

    @media (max-width: 480px) {
      grid-template-columns: 1fr;
    }
  `,

  PerformanceCard: styled.div`
    display: flex;
    flex-direction: column;
    padding: 20px;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(20px);
    box-shadow:
      0 4px 20px rgba(0, 0, 0, 0.1),
      inset 0 1px 0 rgba(255, 255, 255, 0.1);
    border-radius: 16px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    overflow: hidden;
    text-align: center;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(
        135deg,
        rgba(255, 255, 255, 0.04) 0%,
        rgba(255, 255, 255, 0.01) 50%,
        rgba(237, 162, 17, 0.02) 100%
      );
      border-radius: 16px;
      pointer-events: none;
    }

    &:hover {
      background: rgba(255, 255, 255, 0.08);
      border-color: rgba(237, 162, 17, 0.3);
      transform: translateY(-4px);
      box-shadow:
        0 8px 25px rgba(0, 0, 0, 0.15),
        inset 0 1px 0 rgba(255, 255, 255, 0.2);
    }

    &.non-clickable {
      cursor: default;
      opacity: 0.7;
      
      &:hover {
        background: rgba(255, 255, 255, 0.05);
        border-color: rgba(255, 255, 255, 0.1);
        transform: none;
        box-shadow:
          0 4px 20px rgba(0, 0, 0, 0.1),
          inset 0 1px 0 rgba(255, 255, 255, 0.1);
      }

      &::before {
        background: linear-gradient(
          135deg,
          rgba(255, 255, 255, 0.02) 0%,
          rgba(255, 255, 255, 0.005) 50%,
          rgba(255, 255, 255, 0.01) 100%
        );
      }

      .metric-label {
        color: rgba(255, 255, 255, 0.5);
      }

      .metric-value {
        color: rgba(255, 255, 255, 0.6);
        text-shadow: none;
      }
    }

    .metric-label {
      font-size: 12px;
      font-weight: 500;
      color: rgba(255, 255, 255, 0.7);
      margin-bottom: 8px;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      position: relative;
      z-index: 1;
    }

    .metric-value {
      font-size: 28px;
      font-weight: 700;
      color: rgba(255, 255, 255, 1);
      text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
      position: relative;
      z-index: 1;
    }

    &.matches {
      .metric-value {
        color: #eda211;
      }
    }

    &.wins {
      .metric-value {
        color: #14c911;
      }
    }

    &.defeats {
      .metric-value {
        color: #ff6b6b;
      }
    }

    &.draw {
      .metric-value {
        color: #ffa500;
      }
    }

    &.no-show {
      .metric-value {
        color: #ff6b6b;
      }
    }
  `,

  PerformanceRow: styled.div`
    margin: 0 20px;
    display: flex;
    flex-wrap: wrap;
    gap: 16px;

    @media (max-width: 767px) {
      margin: 0 10px;
      gap: 12px;
    }
  `,
  PerformanceCol: styled.div`
    padding: 0 5px;
    width: 50%;

    @media (max-width: 767px) {
      width: 100%;

      & + & {
        margin-top: 5px;
      }
    }
  `,
  PerformanceData: styled.div`
    display: flex;

    & + & {
      margin-top: 8px;
    }

    div {
      border: 1px solid rgba(255, 255, 255, 0.1);
      box-sizing: border-box;
      border-radius: 12px;
      font-weight: 600;
      font-size: 14px;
      padding: 12px 16px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      background: rgba(255, 255, 255, 0.05);
      backdrop-filter: blur(10px);
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      box-shadow:
        0 2px 8px rgba(0, 0, 0, 0.1),
        inset 0 1px 0 rgba(255, 255, 255, 0.1);
      color: rgba(255, 255, 255, 0.9);
      text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);

      &:first-child {
        width: 100%;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        border-right: none;
      }

      &:last-child {
        width: 33%;
        flex-shrink: 0;
        margin-left: 0;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        background: rgba(255, 255, 255, 0.08);
        font-weight: 700;
        color: rgba(255, 255, 255, 1);
        text-align: center;
      }

      &:hover {
        background: rgba(255, 255, 255, 0.08);
        border-color: rgba(237, 162, 17, 0.3);
        transform: translateY(-1px);
        box-shadow:
          0 4px 12px rgba(0, 0, 0, 0.15),
          inset 0 1px 0 rgba(255, 255, 255, 0.2);
      }
    }

    .profile__perfomance-matches-button:hover {
      color: #eda211;
      cursor: pointer;
      border-color: #eda211;
      background: rgba(237, 162, 17, 0.1);
    }

    .green {
      color: #14c911;
    }

    .red {
      color: #ff6b6b;
    }
  `,
  PerformanceControls: styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 0 20px;

    @media (max-width: 767px) {
      flex-direction: column;

      button + button {
        margin-top: 10px;
      }
    }
  `,
  NoTableData: styled.div`
    font-size: 14px;
  `,
  TableHero: styled.div`
    display: flex;
    align-items: center;

    img {
      display: block;
      margin-right: 8px;
    }
  `,
  AddResults: styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media (max-width: 767px) {
      flex-direction: column;
    }

    .copy {
      font-weight: bold;
      font-size: 21px;
      color: #d5cbff;

      @media (max-width: 767px) {
        margin-bottom: 20px;
      }
    }
  `,
}

export default Styled
